<template>
    <v-container fluid tag="section" class="mt-4 bg-white border rounded shadow" v-if="datos_empleado.id_tipo_trabajador != 4 && datos_empleado != null">

        <v-row justify="center" class="mb-4">
            <v-col cols="12" sm="4">
                <v-btn
                    color="success"
                    block
                    class="text-caption text-sm-body-2"
                    @click="descargarArchivo(datos_aseguradora.url)"
                >
                    <v-icon start>mdi-download</v-icon>
                    <span class="d-none d-sm-inline">DESCARGAR FORMATO DE CONSENTIMIENTO</span>
                    <span class="d-inline d-sm-none">DESCARGAR FORMATO</span>
                </v-btn>
            </v-col>
            <v-col cols="12" sm="4">
                <v-btn
                    color="info"
                    block
                    class="text-caption text-sm-body-2"
                    @click="abrirModal()"
                >
                    <v-icon start>mdi-upload</v-icon>
                    <span class="d-none d-sm-inline">SUBIR FORMATO DE CONSENTIMIENTO</span>
                    <span class="d-inline d-sm-none">SUBIR FORMATO</span>
                </v-btn>
            </v-col>
            <v-col cols="12" sm="4">
                <v-btn
                    color="error"
                    block
                    class="text-caption text-sm-body-2"
                    @click="descargarGuiaLlenado()"
                    outlined
                    style="background-color: white;"
                >
                    <v-icon start>mdi-file-document</v-icon>
                    <span class="d-none d-sm-inline">VER GUÍA DE LLENADO</span>
                    <span class="d-inline d-sm-none">VER MUESTRA</span>
                </v-btn>
            </v-col>
        </v-row>
              <v-row >


                  <br>
                  <v-col v-if="showTable " cols="12" sm="12">
                      <v-client-table :data="dataEmpleadoSeguroVida" :columns="columns" :options="options">
                          <template slot="acciones" slot-scope="empleado">
                              <v-menu bottom right>
                                  <template v-slot:activator="{ on, attrs }">
                                      <v-btn icon v-bind="attrs" v-on="on">
                                          <v-icon>mdi-dots-vertical</v-icon>
                                      </v-btn>
                                  </template>
                                  <v-list>
                                      <v-list-item   @click="descargarArchivo(empleado.row.file_path)">
                                          <v-list-item-icon>
                                              <v-icon class="text-success">mdi-download-box</v-icon>
                                          </v-list-item-icon>
                                          <v-list-item-title>DESCARGAR</v-list-item-title>
                                      </v-list-item>

                                  </v-list>
                                  <v-list>
                                      <v-list-item   @click="descargarAcuse(empleado.row.file_path)">
                                          <v-list-item-icon>
                                              <v-icon class="text-success">mdi-download-box</v-icon>
                                          </v-list-item-icon>
                                          <v-list-item-title>DESCARGAR ACUSE</v-list-item-title>
                                      </v-list-item>

                                  </v-list>
                              </v-menu>
                          </template>
                          <template slot="estatus" slot-scope="status">
                              <span v-if="status.row.estatus ==1 " class="sne-alert alert-success sne-rounded-small sne-py-1 text-center sne-mx-auto"  >
                                  ACTIVO
                              </span>
                              <span v-else class="sne-alert alert-danger sne-rounded-small sne-py-1 text-center sne-mx-auto"  >INACTIVO</span>
                          </template>
                      </v-client-table>

                      <!-- PROPUESTA REFINADA: INTEGRACIÓN DE SUELDO TABULAR -->
                      <!-- Nota: He ajustado el max-width para que no se vea tan ancho en pantallas grandes -->
                      <v-card
                        class="mx-auto mt-n2 rounded-t-0 card-sueldo-tabular"
                        elevation="0"
                        style="border: none;"
                      >
                        <div class="pa-4 pa-md-6 d-flex justify-center bg-slate-50">
                          <div class="text-center w-full">
                            <v-sheet
                              elevation="2"
                              rounded="xl"
                              class="px-4 px-md-10 py-4 bg-white d-flex flex-column align-center border"
                              style="border-color: #1976D2 !important; border-width: 1px;"
                            >
                              <div class="d-flex align-center justify-center mb-1 flex-wrap">
                                <v-icon color="primary" size="small" class="mr-2 flex-shrink-0">mdi-cash-register</v-icon>
                                <span class="text-caption text-uppercase text-medium-emphasis font-weight-black title-sueldo-tabular">
                                  Sueldo Líquido Tabular Mensual
                                </span>
                              </div>

                              <!-- Formateo de moneda integrado -->
                              <span class="text-h4 font-weight-black text-primary">
                                {{ new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(importe_tabular) }}
                              </span>

                              <v-divider class="w-full my-2"></v-divider>

                              <span class="text-caption text-grey-darken-1 italic">
                                Importe calculado de acuerdo al tabulador vigente
                              </span>
                            </v-sheet>
                          </div>
                        </div>
                      </v-card>

                  </v-col>
              </v-row>


          </v-row>

          <!-- Modal -->
           <!-- Modal -->
            <v-dialog v-model="showModal" persistent max-width="600px">
            <v-card>
                <v-card-title class="headline">{{ titulo_modal }}</v-card-title>
                <v-card-text>
                <v-form ref="form">


                    <!-- Dropbox Component -->
                    <div class="mt-4">
                    <h3 class="subtitle-1 mb-2">Archivos adjuntos</h3>
                    <div class="file-dropbox">
                        <div
                        class="upload-zone"
                        :class="{ 'active-dropzone': isDragging, 'has-files': files.length > 0 }"
                        @dragover.prevent="isDragging = true"
                        @dragleave.prevent="isDragging = false"
                        @drop.prevent="onDrop"
                        @click="triggerFileInput"

                        >
                        <input
                            ref="fileInput"
                            type="file"
                            multiple
                            accept=".pdf,image/*"
                            style="display: none"
                            @change="onFileSelected"

                        />

                        <div class="text-center" v-if="files.length === 0">
                            <v-icon size="40" color="primary">mdi-cloud-upload-outline</v-icon>
                            <div class="mt-2 body-1">haz clic para seleccionar o arrastra archivos aquí</div>
                            <p class="text-caption text-medium-emphasis">
                            Formatos aceptados: PDF
                            </p>
                        </div>

                        <div v-else class="file-list">
                            <v-list dense>
                            <v-list-item v-for="(file, index) in files" :key="index" dense>
                                <v-list-item-avatar size="32" color="grey lighten-3" class="mr-2">
                                <v-icon :color="getFileIconColor(file)" small>{{ getFileIcon(file) }}</v-icon>
                                </v-list-item-avatar>

                                <v-list-item-content>
                                <v-list-item-title class="text-truncate subtitle-2">{{ file.name }}</v-list-item-title>
                                <v-list-item-subtitle class="caption">{{ formatFileSize(file.size) }}</v-list-item-subtitle>
                                </v-list-item-content>

                                <v-list-item-action v-if="!es_subir_archivo">
                                <v-btn icon x-small @click.stop="removeFile(index)">
                                    <v-icon color="error" small>mdi-close-circle</v-icon>
                                </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                            </v-list>
                        </div>
                        </div>
                    </div>
                    </div>
                    <!-- End Dropbox Component -->

                </v-form>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="showModal = false,resetForm()">Cancelar</v-btn>
                <v-btn color="blue darken-1"  text @click="guardar_archivo_seguro_vida">Guardar</v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
            <!--  -->
            <v-snackbar
                v-model="snackbar.show"
                :color="snackbar.color"
                timeout="3000"
                >
                {{ snackbar.text }}
            </v-snackbar>
          <!-- Incluye el componente ModalEspera -->
          <ModalEspera ref="modalEspera"/>
    </v-container>
    <v-container fluid tag="section" class="mt-4 bg-white border rounded shadow text-center" v-else>
        <h2 class="title">Acceso restringido</h2>
        <p class="subtitle">No tienes permisos para acceder a esta sección.</p>
    </v-container>

</template>
<script>
import { mapState } from 'vuex'
import ModalEspera from "./ModalWait.vue";

export default {
    components: {
        ModalEspera,
    },
    data:function(){
        return {

            userData : [],
            dataEmpleadoSeguroVida : [],
            mostrar_tabla_empleado : false,
            showTable :false,
            columns: ['no_empleado', 'rfc', 'nombre', 'ap_paterno', 'ap_materno', 'no_plaza', 'nivel','aseguradora','anio','estatus','created_at', 'acciones'],
            options: {
                headings: {
                    no_empleado: '# EMPLEADO',
                    rfc: 'RFC',
                    nombre: 'NOMBRE',
                    ap_paterno: 'APELLIDO PATERNO',
                    ap_materno: 'APELLIDO MATERNO',
                    no_plaza: 'N° PLAZA',
                    nivel: 'NIVEL',
                    aseguradora: 'ASEGURADORA',
                    anio: 'AÑO',
                    estatus: 'ESTATUS',
                    created_at : 'FECHA CREACIÓN',
                    acciones: 'ACCIONES'

                },
                sortable: ['no_empleado', 'rfc', 'nombre', 'ap_paterno', 'ap_materno', 'no_plaza', 'nivel'],
                texts: {
                    count:"",
                    filter:"Buscar:",
                    filterPlaceholder: 'Buscar...',
                    limit:"Resultados:",
                    recordsDisplay: 'Resultados',
                    page:"Página:",
                    noResults:"No hay resultados",
                    filterBy: 'Buscar...',
                    loading:'Cargando...',
                    defaultOption: 'Seleccionar {column}'
                },
                filterable: true,
                filterByColumn: false,
                resizableColumns: false,
                sendEmptyFilters :false,
                childRowTogglerFirst: true,
                showChildRowToggler: true,
                perPage: 5,
                perPageValues: [5, 10, 15, 20],
                filterable: ['no_empleado', 'rfc', 'nombre', 'ap_paterno', 'ap_materno', 'no_plaza', 'nivel'],
                    templates: {

                    }, filterByColumn: true,
            },

            //modal subir documentos
            showModal: false,
            titulo_modal: '',
            ticket: '',
            respuesta_ticket: '',
            tipo_accion_modal_ticket: 'GUARDAR', // GUARDAR, EDITAR, VER
            es_subir_archivo: false,
            datos_aseguradora: [],
            importe_tabular: 0,
            datos_empleado: [],

            // Dropbox component data
            isDragging: false,
            files: [],
            isUploading: false,
            snackbar: {
                show: false,
                text: '',
                color: 'success'
            }
        }
    },
    computed:{
        ...mapState(["user"]),
        ...mapState(["token"]),
        ...mapState(["baseUrl"])
    },
    async mounted(){
        await this.obtener_importe_tabular();
        if(this.datos_empleado.id_tipo_trabajador != 4){
          await this.validar_terminos_condiciones();
        }
        await this.buscarRegistrosActivos();
        await this.obtener_aseguradora_activa();
    },
    methods: {
        async validar_terminos_condiciones(){

            try{
                 let response = await this.$http.get("seguro-vida-validar-aceptar-termino-condicion/"+this.user.id_empleado);

                this.userData               = response.data.data.userData;
                if(this.userData == false){
                     this.aceptar_termino_condicion()
                }



            }catch(error){
                this.showAlert = true;
            }
        },

        aceptar_termino_condicion: async function() {
            try {
                const result = await this.$swal({
                    title: 'IMPORTANTE',
                    content: {
                        element: 'div',
                        attributes: {
                            innerHTML: `
                                <div style="text-align: left; font-size: 14px; margin-top: 15px;">
                                    <ul style="padding-left: 20px; margin: 10px 0; text-align: left; list-style-type: disc;">
                                        <li style="margin-bottom: 8px;">Lea cuidadosamente la información solicitada en cada campo antes de iniciar el llenado correspondiente.</li>
                                        <li style="margin-bottom: 8px;">En caso de llenarse a mano, escriba con claridad y con letra de molde legible (utilice únicamente bolígrafo de tinta azul).</li>
                                        <li style="margin-bottom: 8px;">La firma autógrafa del asegurado, deberá ser lo más parecida a la que aparece en su identificación oficial vigente (INE), para garantizar su autenticidad y validez.</li>
                                        <li>En caso de que alguno de los procedimientos previamente mencionados no se lleve a cabo de manera adecuada y se omita la entrega del consentimiento individual para el seguro de grupo de vida temporal a un año renovable denominado “PRESTACIONES”, se considerará intestado hasta que la autoridad competente determine legalmente a las personas que puedan realizar dicho cobro.</li>
                                    </ul>
                                </div>
                            `
                        }
                    },
                    icon: 'warning',
                    buttons: {
                        cancel: {
                            text: "Cancelar",
                            value: false,
                            visible: true,
                            className: "swal-cancel-button"
                        },
                        confirm: {
                            text: "Aceptar",
                            value: true,
                            className: "swal-confirm-button"
                        }
                    },
                    reverseButtons: true,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    width: '650px',
                    className: 'swal-wide'
                });

                if (result) {
                    // Lógica cuando acepta
                    let form = new FormData();
                    form.append("id_user", this.user.id_user);

                    let response = await this.$http.post("seguro-vida-aceptar-termino-condicion", form);
                    if (response.data.response) {
                        // this.$toasted.success('TERMINOS Y CONDICIONES ACEPTADOS CORRECTAMENTE');
                        // this.validar_terminos_condiciones();
                    }
                } else {
                    // Si cancela, volver a mostrar
                    // this.$router.push('/panel/pages/comprobantes');
                }

            } catch(error) {
                console.error("Error:", error);
                Swal.fire('Error', 'Ocurrió un problema al procesar la solicitud', 'error');
            }
        },

        async buscarRegistrosActivos(){
            try{
                this.showTable = false
                 let response = await this.$http.get("get-seguro-vida-empleado/"+this.user.id_empleado);

                this.dataEmpleadoSeguroVida = response.data.data.activos;
                if(this.dataEmpleadoSeguroVida){
                    this.showTable = true
                }else{
                    this.dataEmpleadoSeguroVida = []
                    this.showTable = true
                }

                this.mostrar_tabla_empleado = true



            }catch(error){

            }
        },
        descargarArchivo(file_path){
            window.open(this.baseUrl + "seguro-vida-descargar-archivo?token="+this.token+"&file_path="+file_path,"_blank");
        },

        //

        guardar_archivo_seguro_vida:async function(){

            try{
                var mensaje = '¿Estas seguro de guardar el archivo?'
                var mensaje_advertencia = ''
                var mensaje_form_cuatri = 'EL ARCHIVO SE HA GUARDADO EXITOSAMENTE!!'

                this.$swal({
                    className: "text-center",
                    title: mensaje,
                    text: mensaje_advertencia,
                    icon: "warning",
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    reverseButtons: true,
                    buttons:["Cancelar","Aceptar"],
                    }).then(async (value) => {
                        if(value){
                        this.$refs.modalEspera.mostrarModal = true;
                        let form = new FormData();
                        // form.append("tipo_nomina",this.tipoNomina);
                        form.append("id_empleado",this.user.id_empleado);
                        form.append("id_aseguradora", this.datos_aseguradora.id);
                            this.files.forEach((file, index) => {
                                form.append(`file`, file);
                        });

                        let response = await this.$http.post("seguro-vida-guardar-archivo",form);
                        if(response.data.response){
                            this.resetForm()
                            this.$toasted.success(mensaje_form_cuatri);

                            setTimeout(() => {
                                this.$toasted.success('TERMINOS Y CONDICIONES ACEPTADOS CORRECTAMENTE');
                            }, 5000);

                            this.$refs.modalEspera.mostrarModal = false;
                            this.showModal = false;
                            await this.buscarRegistrosActivos();
                            this.descargarAcuse();

                        }else{
                            this.$refs.modalEspera.mostrarModal = false;
                            this.showModal = false;
                            this.resetForm()
                            this.$swal({
                                title: response.data.error,
                                text: "",
                                icon: "error",
                                button:"Aceptar"
                            }).then(() => this.dialog = true);


                        }
                    }
                });
            }catch(error){
                this.$refs.modalEspera.mostrarModal = false;
                this.showModal = false;
                console.log(error)
            }
        },



        validarFormulario() {
            if (!this.files.trim()) {
                this.showSnackbar('La descripción del ticket es obligatoria', 'error');
                return false;
            }
            return true;
        },

        resetForm() {
            this.files = [];
        },

        abrirModal(tipo, datos = null) {
            this.titulo_modal = 'Subir archivos';
            this.showModal = true;
        },

        // Métodos para el dropbox
        triggerFileInput() {
            if (!this.es_subir_archivo) {
                this.$refs.fileInput.click();
            }
        },

        onDrop(e) {
            if (this.es_subir_archivo) return;

            this.isDragging = false;
            const droppedFiles = e.dataTransfer.files;
            this.processFiles(droppedFiles);
        },

        onFileSelected(e) {
            const selectedFiles = e.target.files;
            this.processFiles(selectedFiles);
        },

        processFiles(fileList) {
            // Filtrar archivos no permitidos
            const validFiles = Array.from(fileList).filter(file => {
                const isPDF = file.type === 'application/pdf';
                // const isImage = file.type.startsWith('image/');
                return isPDF;
            });

            // Alertar si hay archivos no válidos
            if (validFiles.length < fileList.length) {
                this.showSnackbar('Algunos archivos fueron ignorados. Solo se permiten PDF.', 'warning');
            }

            if(this.files.length>0){
                this.showSnackbar('Solo se puede subir un archivo', 'warning');
                return false;
            }

            // Añadir archivos válidos
            this.files.push(...validFiles);

            // Limpiar input para permitir seleccionar el mismo archivo nuevamente
            this.$refs.fileInput.value = '';
        },

        removeFile(index) {
            this.files.splice(index, 1);
        },

        showSnackbar(text, color = 'success') {
            this.snackbar.text = text;
            this.snackbar.color = color;
            this.snackbar.show = true;
        },

        getFileIcon(file) {
            if (file.type === 'application/pdf') {
                return 'mdi-file-pdf-box';
            } else if (file.type.startsWith('image/')) {
                return 'mdi-file-image';
            }
            return 'mdi-file';
        },

        getFileIconColor(file) {
            if (file.type === 'application/pdf') {
                return 'red';
            } else if (file.type.startsWith('image/')) {
                return 'blue';
            }
            return 'grey';
        },

        formatFileSize(bytes) {
            if (bytes === 0) return '0 Bytes';
            const k = 1024;
            const sizes = ['Bytes', 'KB', 'MB', 'GB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
        },

        //
        async obtener_aseguradora_activa(){
            try{
                let response = await this.$http.get("seguro-vida-obtener-aseguradora-activa");

                this.datos_aseguradora = response.data.data;

            }catch(error){
                this.showAlert = true;
            }
        },

        async obtener_importe_tabular(){
            try{
                let response = await this.$http.get("seguro-vida-obtener-importe-tabular/"+this.user.id_empleado);

                this.importe_tabular = response.data.data;
                this.datos_empleado = response.data.empleado;

            }catch(error){
                this.showAlert = true;
            }
        },

        descargarAcuse: function(){
            const form = document.createElement('form');
            form.target = "_blank";
            form.method = 'post';
            form.id = 'form';
            form.action = `${this.baseUrl}seguro-vida/descargar-archivo-acuse?token=${this.token}`;

            const empleado = document.createElement('input');
            empleado.type = 'hidden';
            empleado.name = 'empleado';
            empleado.value = this.user.id_empleado;
            form.append(empleado);

            const aseguradora = document.createElement('input');
            aseguradora.type = 'hidden';
            aseguradora.name = 'id_aseguradora';
            aseguradora.value = this.datos_aseguradora.id;
            form.append(aseguradora);

            document.querySelector('body').append(form);
            //-----------------------------------------------------------------------------------------------------
            form.submit();
            document.querySelector('body').removeChild(document.getElementById('form'))
        },
        toCurrency(value){
            let val = (value/1).toFixed(2).replace(',', '.')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        descargarGuiaLlenado(){
            window.open(this.baseUrl + "seguro-vida-descargar-archivo?token="+this.token+"&file_path="+this.datos_aseguradora.url_muestra,"_blank");
        }

    }

}
</script>

<style scoped>
.card-sueldo-tabular {
  width: 100%;
  max-width: 100%;
}

@media (min-width: 600px) {
  .card-sueldo-tabular {
    max-width: 50%;
  }
}

@media (min-width: 960px) {
  .card-sueldo-tabular {
    max-width: 320px;
  }
}

/* Evita que "Sueldo Tabular Mensual" se parta en dos líneas en desktop */
@media (min-width: 600px) {
  .title-sueldo-tabular {
    white-space: nowrap;
  }
}

.title-sueldo-tabular {
  letter-spacing: 0.5px;
}
</style>

<style>
.notification-badge {
    background-color: red;
    color: white;
    border-radius: 55%;
    padding: 8px 12px; /* Ajustado para el doble de tamaño */
    font-size: 14px; /* Ajustado para el doble de tamaño */
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 1030px; /* Margen a la izquierda para separar del icono */
    margin-top: -30px;
}

/* Estilos para el contenedor */
.swal-wide {
    width: 650px !important;
    max-width: 80%;
}

/* Estilos para los botones */
.swal-cancel-button {
    background-color: #f44336 !important;
    color: white !important;
}

.swal-confirm-button {
    background-color: #4CAF50 !important;
    color: white !important;
}

/* Alineación del contenido */
.swal-content {
    text-align: left !important;
    padding: 0 1em !important;
}

.file-dropbox {
  width: 100%;
}

.upload-zone {
  min-height: 150px;
  border: 2px dashed #ccc;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.active-dropzone {
  border-color: #1976d2;
  background-color: rgba(25, 118, 210, 0.05);
}

.has-files {
  min-height: auto;
  justify-content: flex-start;
  align-items: stretch;
}

.file-list {
  width: 100%;
}

/* Estilo para cuando está deshabilitado en modo "ver" */
.upload-zone[disabled] {
  opacity: 0.7;
  cursor: default;
}
</style>
